import { render, staticRenderFns } from "./TibBannerTextInput.vue?vue&type=template&id=a7e29d60"
import script from "./TibBannerTextInput.vue?vue&type=script&lang=js"
export * from "./TibBannerTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports